var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RemoveRedEyeFilled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.7172 4.98828C7.71716 4.98828 3.44716 8.09828 1.71716 12.4883C3.44716 16.8783 7.71716 19.9883 12.7172 19.9883C17.7172 19.9883 21.9872 16.8783 23.7172 12.4883C21.9872 8.09828 17.7172 4.98828 12.7172 4.98828ZM12.7172 17.4883C9.95716 17.4883 7.71716 15.2483 7.71716 12.4883C7.71716 9.72828 9.95716 7.48828 12.7172 7.48828C15.4772 7.48828 17.7172 9.72828 17.7172 12.4883C17.7172 15.2483 15.4772 17.4883 12.7172 17.4883ZM12.7172 9.48828C11.0572 9.48828 9.71716 10.8283 9.71716 12.4883C9.71716 14.1483 11.0572 15.4883 12.7172 15.4883C14.3772 15.4883 15.7172 14.1483 15.7172 12.4883C15.7172 10.8283 14.3772 9.48828 12.7172 9.48828Z",
    fill: "#E3E3E3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEye);
export default __webpack_public_path__ + "static/media/open-eye.7027be6987722494cd80daa5e137a980.svg";
export { ForwardRef as ReactComponent };